import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Curriculum.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Media from '../../components/CommonSet/Media';
import classNames from 'classnames';

class CurriculumAnswer extends BaseComponent {
    constructor(props) {
        super(props);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    createMediaView(media) {
        if (!media) {
            return null;
        }

        return <Media className={classNames(Style.media, Style[media.category])} media={media}/>;
    }

    render() {
        const { item = {} } = this.props;
        const { content = {} } = item;
        const { correctAnswer, answerMedia = {} } = content;

        return (
            <div>
                <div className={Style.popup_wrap}>
                    <div className={Style.pop_header}>
                        <strong className={Style.sjt}>{this.Utils.getLang('Menus.lecture_quiz_popup_title')}</strong>
                    </div>
                    <div className={`${Style.pop_cont} ${Style.result_cont}`}>
                        <p className={Style.result_dsc_box}>
                            <em className={Style.dsc}>
                                {correctAnswer}
                            </em>
                        </p>
                        <div className={Style.thmb_box}>
                            {this.createMediaView(answerMedia)}
                        </div>
                    </div>
                    <span className={Style.pop_close} onClick={() => this.handleButtonClick('close')}>close</span>
                </div>

            </div>
        );
    }
}

CurriculumAnswer.displayName = 'CurriculumAnswer';
CurriculumAnswer.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps,
)(CurriculumAnswer);



// WEBPACK FOOTER //
// ./components/ModalSet/CurriculumAnswer.js